//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//原料进出存明细
const materialsInAndOutStoreList = () =>
  import(
    /* webpackChunkName:'grounp' */ '@/pages/productionCenter/materialsInAndOutStore/list.vue'
  );

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'materialsInAndOutStoreList',
      name: 'materialsInAndOutStoreList',
      component: materialsInAndOutStoreList,
      meta: {
        keepAlive: true,
        title: '原料进出存明细',
      },
    },
  ],
};
export default productionRouter;
